export default __webpack_public_path__ + "static/media/grandPlace3b.2b58c506.jpg";